import { c as _c } from "react/compiler-runtime";
import { useStatusPolling } from '@systemeio/util';
import { getUserPlanKey } from 'modules/profile/user-plan/api/user-plan-api';
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
const POLL_INTERVAL_MS = 2000;
export const useUserPlanUpgradePolling = t0 => {
  const $ = _c(11);
  const {
    targetPlanId,
    allowFetch
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== targetPlanId) {
    t2 = data => !data || !data.userPlans.some(userPlan => userPlan.currentUserPlan && userPlan.id === targetPlanId);
    $[1] = targetPlanId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isPending = t2;
  let t3;
  if ($[3] !== allowFetch || $[4] !== user) {
    t3 = () => allowFetch && user ? [...getUserPlanKey(user.dashboardLocale), "upgrade-poll"] : null;
    $[3] = allowFetch;
    $[4] = user;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isPending) {
    t4 = {
      isPending,
      intervalMs: POLL_INTERVAL_MS
    };
    $[6] = isPending;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data: data_0,
    mutate
  } = useStatusPolling(t3, fetcher, t4, allowFetch);
  const t5 = !isPending(data_0);
  let t6;
  if ($[8] !== mutate || $[9] !== t5) {
    t6 = {
      isUpgradeConfirmed: t5,
      mutate
    };
    $[8] = mutate;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};